import request from '@/utils/request'

// !数据统计
export function dataState (data) {
  return request({
    url: '/SiteTrack/VisitLogs',
    method: 'post',
    data
  })
}

// !留言
export function AddMessage (data) {
  return request({
    url: '/Personal/AddMessage',
    method: 'post',
    data
  })
}

// !微信分享
export function GetWxShare () {
  return request({
    url: 'https://mic.anruicloud.com/wcp/api/jsticket',
    method: 'get',
    params: {
      wechatId: '1701d68b-23a8-402c-b544-a4ce9b8a5623',
      url: window.location.href.split('#')[0]
    }
  })
}